var map = {
	"./aa.jpg": [
		1092,
		29
	],
	"./go_pco.jpg": [
		1093,
		28
	],
	"./go_pvo.jpg": [
		1094,
		27
	],
	"./gpi.jpg": [
		1095,
		26
	],
	"./spr.jpg": [
		1096,
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 879;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/Product/assets lazy ^\.\/.*\.jpg$
// module id = 879
// module chunks = 40